function getUrlParts(hostname: string | null = null) {
  const hostnameToParse = hostname ?? window.location.hostname;
  const result = {
    domain: '',
    type: '',
    subdomain: '',
  };
  const regexParse = /([a-z-0-9]{2,63}).([a-z.]{2,5})$/;
  const parseResult = regexParse.exec(hostnameToParse);
  if (parseResult) {
    [, result.domain, result.type] = parseResult;
  }
  result.subdomain = hostnameToParse.replace(`${result.domain}.${result.type}`, '').slice(0, -1);
  return result;
}

export { getUrlParts };
